import * as React from 'react';
import Svg, { G, Path } from 'react-native-svg';

const GoogleTv: React.FC<SvgProps> = ({ color, ...props }) => (
  <Svg
    width="176.641"
    height="31.3265"
    viewBox="0 0 176.641 31.3265"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <G>
      <G>
        <Path
          d="M157.643 5.08461V6.52894H152.123V23.8873H150.594V6.52894H145.051V5.08461H157.643Z"
          fill={color || '#FFF'}
          stroke="#080F41"
        />
        <Path
          d="M162.271 5.12707L167.579 20.8536L167.694 21.1945H168.529L168.646 20.8595L174.163 5.12707H175.926L169.062 23.9239H167.109L160.504 5.12707H162.271Z"
          fill={color || '#FFF'}
          stroke="#080F41"
        />
        <Path
          d="M59.2232 2.91928C62.2481 2.91928 64.4705 4.01225 66.1832 5.51107L64.7144 6.97982C63.3581 5.83097 61.5958 4.9642 59.2232 4.9642C54.4205 4.96434 50.6754 8.8418 50.6754 13.6038C50.6755 18.3908 54.4152 22.2434 59.2232 22.2435C62.3105 22.2435 64.0854 20.9889 65.2369 19.8695L65.2418 19.8646C66.2138 18.8924 66.8248 17.5098 67.0406 15.7132L67.108 15.1537H59.7232V13.0843H69.1138C69.1679 13.4936 69.1851 13.9698 69.1851 14.4828C69.1851 16.7005 68.5732 19.3842 66.6793 21.307L66.6695 21.3167C64.8071 23.3114 62.4449 24.349 59.2232 24.349C53.311 24.3488 48.3639 19.5301 48.3638 13.6341C48.3638 7.7383 53.3168 2.91942 59.2232 2.91928Z"
          fill={color || '#FFF'}
          stroke="#080F41"
        />
        <Path
          d="M78.509 10.9436C82.1562 10.9493 85.124 13.7388 85.1243 17.6487C85.1243 21.5306 82.1545 24.3547 78.51 24.3548C74.8668 24.3548 71.8957 21.5017 71.8957 17.6487C71.896 13.7385 74.8636 10.9441 78.509 10.9436ZM78.51 12.7757C76.0719 12.7757 74.0014 14.7985 74.0012 17.6487C74.0012 20.4574 76.0364 22.5227 78.51 22.5227C80.9505 22.5227 83.0188 20.4664 83.0188 17.6487C83.0186 14.8076 80.9812 12.7757 78.51 12.7757Z"
          fill={color || '#FFF'}
          stroke="#080F41"
        />
        <Path
          d="M94.4546 10.9374H94.4585C98.0979 10.9093 101.069 13.7291 101.069 17.6434C101.069 21.5252 98.0991 24.3485 94.4546 24.3485C90.8115 24.3485 87.8405 21.4963 87.8404 17.6434C87.8404 13.7326 90.8087 10.9374 94.4546 10.9374ZM94.4546 12.7704C92.0164 12.7704 89.9458 14.793 89.9458 17.6434C89.946 20.452 91.9811 22.5165 94.4546 22.5165C96.8955 22.5164 98.9633 20.4545 98.9634 17.6434C98.9634 14.8021 96.926 12.7704 94.4546 12.7704Z"
          fill={color || '#FFF'}
          stroke="#080F41"
        />
        <Path
          d="M110.218 10.9255C111.791 10.9256 113.009 11.6158 113.634 12.3454L113.784 12.5202H114.636V11.3444H116.619V23.8239C116.619 26.3932 115.867 28.1257 114.737 29.2175C113.603 30.3133 112.023 30.8268 110.248 30.8269C107.284 30.8269 105.393 29.0006 104.536 27.3366L106.385 26.571C107.019 27.7518 108.305 28.988 110.278 28.988C111.575 28.9879 112.685 28.5844 113.467 27.7448C114.244 26.91 114.636 25.7096 114.636 24.236V22.7106H113.778L113.629 22.8923C113.006 23.6462 111.791 24.3365 110.218 24.3366C106.885 24.3366 103.816 21.4306 103.816 17.6618C103.816 13.8598 106.918 10.9255 110.218 10.9255ZM110.46 12.7702C107.948 12.7702 105.951 14.8982 105.951 17.6735C105.951 20.4216 107.986 22.5163 110.46 22.5163C112.951 22.5163 114.817 20.396 114.817 17.6735C114.817 14.9284 112.964 12.7702 110.46 12.7702Z"
          fill={color || '#FFF'}
          stroke="#080F41"
        />
        <Path
          d="M122.163 3.71386V23.9307H119.997V3.71386H122.163Z"
          fill={color || '#FFF'}
          stroke="#080F41"
        />
        <Path
          d="M131.244 10.9376C134.45 10.9376 136.156 13.3351 136.835 14.8946L136.957 15.1944L136.962 15.2071L137.106 15.5567L127.924 19.3458L127.428 19.5509L127.667 20.0313C128.062 20.8233 128.593 21.449 129.267 21.8751C129.941 22.3014 130.729 22.5086 131.607 22.5089V22.5098L131.608 22.5089L131.609 22.5098V22.5089C133.23 22.5144 134.379 21.7843 135.254 20.7013L136.894 21.7813C136.028 22.8804 134.314 24.3486 131.609 24.3487C127.802 24.3487 125.055 21.423 125.055 17.6427C125.055 13.6151 127.837 10.9377 131.244 10.9376ZM131.312 12.7159C129.478 12.7159 126.978 14.3194 127.045 17.4415L127.061 18.1739L127.737 17.8927L134.184 15.212L134.641 15.0216L134.455 14.5636C133.996 13.4221 132.719 12.7161 131.312 12.7159Z"
          fill={color || '#FFF'}
          stroke="#080F41"
        />
      </G>
      <Path
        d="M31.1671 1H10.6736C8.89661 1 7.44709 2.4496 7.44709 4.22673V7.45347H32.4286C34.2056 7.45347 35.6551 8.90307 35.6551 10.6802V5.48831C35.6551 2.98941 33.6355 1 31.1671 1Z"
        fill={color || '#FFF'}
        stroke="#080F41"
        strokeWidth="2"
      />
      <Path
        d="M5.48806 1.00001C3.01962 1.00001 1 3.01975 1 5.48833V16.6121C1 18.3892 2.44952 19.8388 4.22655 19.8388H7.4531V4.22675C7.4531 2.44962 8.90262 1.00001 10.6796 1.00001L5.48806 1.00001Z"
        fill={color || '#FFF'}
        stroke="#080F41"
        strokeWidth="2"
      />
      <Path
        d="M5.48809 26.2862H25.9815C27.7585 26.2862 29.2081 24.8366 29.2081 23.0594V19.8327H4.22658C2.44956 19.8388 1.00004 18.3892 1.00004 16.612V21.8282C1.00004 24.2664 2.98934 26.2862 5.48809 26.2862Z"
        fill={color || '#FFF'}
        stroke="#080F41"
        strokeWidth="2"
      />
      <Path
        d="M31.1671 26.2862C33.6355 26.2862 35.6551 24.2665 35.6551 21.7979V10.6742C35.6551 8.89703 34.2056 7.44743 32.4286 7.44743H29.202V23.0595C29.202 24.8366 27.7586 26.2862 25.9755 26.2862H31.1671Z"
        fill={color || '#FFF'}
        stroke="#080F41"
        strokeWidth="2"
      />
    </G>
  </Svg>
);

export default GoogleTv;
